import {
  autoUpdate,
  computePosition,
  flip,
  offset,
  size,
} from "@floating-ui/vue";
import { VueSelectInstance } from "vue-select";

/**
 * vue-select calls this when the menu opens.
 * Return a cleanup function to tear down listeners.
 */
export function useVueSelectDropdownPosition(
  dropdownEl: HTMLElement,
  component: VueSelectInstance,
  { width }: { width: string }
) {
  // Ensure correct layer + base styles
  Object.assign(dropdownEl.style, {
    position: "fixed",
    zIndex: 3000,
    width, // match trigger width
    maxWidth: width,
    overflow: "auto",
  });

  const referenceEl = component.$refs.toggle;

  // Keep it positioned while scrolling/resizing, even inside modals
  const stop = autoUpdate(referenceEl, dropdownEl, () => {
    computePosition(referenceEl, dropdownEl, {
      placement: "bottom-start",
      strategy: "fixed",
      middleware: [
        offset(6),
        flip({ fallbackPlacements: ["top-start"] }),
        size({
          padding: 8,
          apply({ availableHeight, rects }) {
            // Cap height to available space (with a sensible ceiling/floor)
            const max = Math.min(availableHeight, 360);
            dropdownEl.style.maxHeight = `${Math.max(120, max)}px`;
            dropdownEl.style.minWidth = `${rects.reference.width}px`;
          },
        }),
      ],
    }).then(({ x, y }) => {
      Object.assign(dropdownEl.style, { left: `${x}px`, top: `${y}px` });
    });
  });

  // vue-select will call this when the menu closes
  return () => stop();
}
